import axios from "axios";
import config from "../config/config";
import { GameDataContext } from "../component/Context/GameDataContext";
export const CreateGame = async (body) => {
  try {
    let { data } = await axios.post(`${config.apiURL}challenge`, body);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const JoinGame = async (player_id, game_id) => {
  try {
    let { data } = await axios.post(
      `${config.apiURL}challenge/join/${game_id}`,
      { player_id }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const FetchGames = async () => {
  try {
    let { data } = await axios.get(`${config.apiURL}games`);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const FindGame = async (body, query) => {
  body.isCustomBet = query;
  try {
    let { data } = await axios.post(`${config.apiURL}challenge/find`, body);
    return data;
  } catch (error) {
    return error.msg;
  }
};

export const SubmitScore = async (game_id, body) => {
  try {
    let { data } = await axios.post(
      `${config.apiURL}challenge/score/${game_id}`,
      body
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const GetGameDetails = async (game_name) => {
  try {
    let { data } = await axios.get(`${config.apiURL}games/${game_name}`);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const UserLogin = async (payload) => {
  try {
    let { data } = await axios.post(`${config.apiURL}user`, payload);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const gameHistory = async (player_id) => {
  try {
    let { data } = await axios.get(
      `${config.apiURL}challenge/user/history/?playerId=${player_id}`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const profileDetails = async (player_id, page, perpage) => {
  try {
    let { data } = await axios.get(
      `${config.apiURL}challenge/${player_id}?page=${page}&limit=${perpage}`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const customBets = async (id, name) => {
  try {
    let { data } = await axios.get(
      `${config.apiURL}challenge/bets/custom/${id}?gameName=${name}`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const integrationServiceForm = async (data) => {
  try {
    let response = await axios.post(`${config.apiURL}email`, data);
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

export const verifyRoom = async (code) => {
  try {
    let response = await axios.get(
      `${config.apiURL}challenge/invite/${parseInt(code)}`
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const blogCategories = async () => {
  try {
    let { data } = await axios.get(`${config.apiURL}categories`);
    return data;
  } catch (error) {
    return error;
  }
};

export const contactUs = async (body) => {
  try {
    let { data } = await axios.post(`${config.apiURL}email`, body);
    return data;
  } catch (error) {
    return error;
  }
};

export const contactSupport = async (body) => {
  try {
    let { data } = await axios.post(`${config.apiURL}email`, body);
    return data;
  } catch (error) {
    return error;
  }
};
